import React, { useState, useEffect, useLayoutEffect } from "react";
import { getUserData, removeUserData } from "./app/services/security"; // Import auth helpers
import apiService from "./ApiService"; // Import API service for HTTP requests
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"; // Import Routes
import { useNavigate } from "react-router-dom";
import ClientTable from "./app/components/overviewOfAllClients/ClientTable";
import ClientDashboard from "./app/pages/dashboard/clientDashboard/ClientDashboard";
import ClientRegistrationPage from "./app/pages/ClientRegistrationPage";
import SleepEntryForm from "./app/components/clientCoachUpdates/clientSection/OLD_sleepEntryForm/SleepEntryForm";
import WeeklyCheckIn from "./app/pages/WeeklyCheckIn";
import LoginPage from "./app/pages/authentification/login/LoginPage";
import PrivateRoute from "./app/services/PrivateRoute";
import UnauthorizedPage from "./app/pages/authentification/unauthorized/Unauthorized";
import { useUser } from "./app/pages/authentification/UserContext";
import GlobalStyle from "./globalStyles";
// import Dropdown from "./app/components/dropdown/Dropdown";
import Footer from "./app/components/footer/Footer";
import Home from "./app/pages";
import CoachingTypesPresentationPage from "./app/pages/coachingTypes/CoachingTypesPresentationPage";
import Contact from "./app/pages/Contact";
import Homes from "./app/pages/Homes";
import Aos from "aos";
import "aos/dist/aos.css";
import MensurationsDashboard from "./app/pages/mensurations/MensurationsDashboard";
import Weight from "./app/pages/Weight";
import Coach from "./app/pages/Coach";
import WeightDashboard from "./app/pages/weight/WeightDashboard";
import Bilan from "./app/pages/Bilan";
import ChangePassword from "./app/pages/ChangePassword";
import Logout from "./app/pages/Logout";
import { setAuthToken } from "./ApiService";
import {
  menuData,
  menuDataAdmin,
  menuDataUser,
} from "./app/components/navbar/data/MenuData";
import CoachingNutrition from "./app/pages/coachingTypes/CoachingNutrition";
import CoachingMusculation from "./app/pages/coachingTypes/CoachingMusculation";
import CoachingMuscuNutri from "./app/pages/coachingTypes/CoachingMuscuNutri";
import Ebook from "./app/pages/Ebook";
import RemplirLeCheckIn from "./app/ptknowledge/fichesclients/RemplirLeCheckIn";
import TraquerSesProgres from "./app/ptknowledge/fichesclients/TraquerSesProgres";
import FormulaireDebutCoachingMainPage from "./app/pages/formulaires/formulaireDebutCoaching/FormulaireDebutCoachingMainPage";
import AddMensurations from "./app/pages/mensurations/AddMensurations";
import ListeDesMacronutriments from "./app/ptknowledge/nutrition/ListeDesMacronutriments";
import CreationRecetteMainPage from "./app/pages/recettes/CreationRecetteMainPage";
import ListeDeRecettesMainPage from "./app/pages/recettes/display/ListeDeRecettesMainPage";
import RecetteDetail from "./app/pages/recettes/display/RecetteDetail";
import MuscleGroupCreationPage from "./app/pages/fitness/coreExercises/muscleGroup/MuscleGroupCreationPage";
import EquipmentCreationPage from "./app/pages/fitness/coreExercises/equipment/EquipmentCreationPage";
import ExerciseCreationPage from "./app/pages/fitness/coreExercises/exercise/ExerciseCreationPage";
import ExerciseIntensityPage from "./app/pages/fitness/coreExercises/exerciseIntensity/ExerciseIntensityPage";
import ExerciseListingPage from "./app/pages/fitness/coreExercises/exercise/ExerciseListingPage";
import NutritionProgramPageDebutCoaching from "./app/pages/nutrition/nurtritionDebutCoaching/NutritionProgramPageDebutCoaching";
import AdviceNutritionPage from "./app/pages/nutrition/consulting/AdviceNutritionPage";
import OverviewClientsPage from "./app/pages/clients/OverviewClientsPage";
import ResponsiveNavbar from "./app/components/navbar/ResponsiveNavbar";
import DessertsProteines from "./app/ptknowledge/nutrition/DessertsProteines";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { user, setUser } = useUser();
  const [menu, setMenu] = useState(menuData);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  // Scroll to top on route change
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Combined effect: Restore user data and fetch profile
  useEffect(() => {
    const restoreAndFetchUser = async () => {
      // Retrieve stored user data using your helper
      const storedUser = getUserData();
      console.log("Restoring user data:", storedUser); // <-- Add this log for debugging

      if (storedUser && storedUser.token) {
        // Set Axios default header before making API calls
        setUser(storedUser);
        setAuthToken(storedUser.token);
      } else {
        console.warn("No stored user found");
        // No valid stored user found
        setUser(null);
      }
      // Finished restoration/fetching – stop loading
      setLoading(false);
    };

    restoreAndFetchUser();
  }, [setUser]);

  // Initialize AOS animations
  useEffect(() => {
    Aos.init({});
  }, []);

  // Set the menu based on the user role (if user exists)
  useEffect(() => {
    if (!user || !user.token) {
      setMenu(menuData);
      return; // ✅ Stops execution if user is null
    }

    if (user.role === "ROLE_ADMIN") {
      setMenu(menuDataAdmin);
    } else if (user.role === "ROLE_USER") {
      setMenu(menuDataUser(user.id));
    }
  }, [user]);

  const handleLogout = () => {
    console.log("🔄 Logging out...");
    removeUserData(); // Clear user from storage
    setUser(null); // Reset context
    navigate("/login");
  };

  if (loading) return <div>Loading...</div>; // ✅ Prevents flickering before rendering

  return (
    <>
      <GlobalStyle />
      <ResponsiveNavbar
        menuItems={menu}
        user={user}
        handleLogout={handleLogout}
      />

      <Routes>
        {/* Public Routes */}
        <Route path="/" exact element={<Home />} />
        <Route path="/coach" exact element={<Coach />} />
        <Route
          path="/coachingtypes"
          exact
          element={<CoachingTypesPresentationPage />}
        />
        <Route
          path="/coachingtypes/coachingnutrition"
          exact
          element={<CoachingNutrition />}
        />
        <Route
          path="/coachingtypes/coachingmusculation"
          exact
          element={<CoachingMusculation />}
        />
        <Route
          path="/coachingtypes/coachingmuscunutri"
          exact
          element={<CoachingMuscuNutri />}
        />
        <Route path="/ebook" exact element={<Ebook />} />
        <Route path="/homes" exact element={<Homes />} />
        <Route path="/contact" exact element={<Contact />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/logout" element={<Logout onLogout={handleLogout} />} />
        <Route path="/login" element={<LoginPage />} />

        {/* User must be logged in, but form completion is NOT required */}
        <Route
          element={
            <PrivateRoute
              allowedRoles={["ROLE_USER", "ROLE_ADMIN"]}
              requiresFormCompleted={false}
            />
          }
        >
          <Route
            path="/debutformulaire"
            element={<FormulaireDebutCoachingMainPage />}
          />
        </Route>

        {/* User must be logged in & form must be completed */}

        <Route
          element={
            <PrivateRoute
              allowedRoles={["ROLE_USER", "ROLE_ADMIN"]}
              requiresFormCompleted={true}
            />
          }
        >
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard/:clientID" element={<ClientDashboard />} />
          {/* User Routes */}
          <Route path="/weightupdate/:clientID" element={<Weight />} />
          <Route
            path="/weeklycheckinform/:clientID"
            element={<WeeklyCheckIn />}
          />
          <Route
            path="/mensurationupdate/:clientID"
            element={<AddMensurations />}
          />
          <Route
            path="/mensurationdashboard/:clientID"
            element={<MensurationsDashboard />}
          />
          <Route
            path="/weightdashboard/:clientID"
            element={<WeightDashboard />}
          />
          <Route
            path="/changepassword/:clientID"
            element={<ChangePassword />}
          />

          {/* Nutrition Routes */}
          <Route path="/recettes" element={<ListeDeRecettesMainPage />} />
          <Route path="/recettes/:recetteId" element={<RecetteDetail />} />

          {/* Fitness Routes */}
          <Route path="/exerciselisting" element={<ExerciseListingPage />} />

          {/* Documents */}
          <Route
            path="/documents/commentremplirlecheckin"
            element={<RemplirLeCheckIn />}
          />
          <Route
            path="/documents/traquersonprogres"
            element={<TraquerSesProgres />}
          />
          <Route
            path="/documents/listedesmacronutrients"
            element={<ListeDesMacronutriments />}
          />
          <Route
            path="/documents/dessertsproteines"
            element={<DessertsProteines />}
          />
        </Route>
        {/* Admin & Coach Routes (Require Form Completion) */}
        <Route
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_COACH"]}
              requiresFormCompleted={false}
            />
          }
        >
          {/* Coaching Routes */}
          <Route path="/clients" element={<OverviewClientsPage />} />

          <Route path="/newclient" element={<ClientRegistrationPage />} />
          <Route path="/bilan/:clientID" element={<Bilan />} />
          <Route path="/newrecipe" element={<CreationRecetteMainPage />} />
          <Route path="/sleepupdate/:clientID" element={<SleepEntryForm />} />
          <Route path="/musclecreation" element={<MuscleGroupCreationPage />} />
          <Route path="/exercisecreation" element={<ExerciseCreationPage />} />
          <Route
            path="/exerciseintensity"
            element={<ExerciseIntensityPage />}
          />
          <Route path="/exerciselisting" element={<ExerciseListingPage />} />
          <Route
            path="/equipmentcreation"
            element={<EquipmentCreationPage />}
          />

          <Route
            path="/nutritioncalculation"
            element={<NutritionProgramPageDebutCoaching />}
          />
          <Route path="/advicenutrition" element={<AdviceNutritionPage />} />
          {/* <Route
            path="/update/:clientID"
            element={<UpdateClientInformationPage />}
          /> */}
        </Route>
      </Routes>
      <Footer />
    </>
  );
};

export default App;
